import type { AllRouteEndpoints } from "../routeTypes";

export const engagementIosNotificationGroups = "/engagement/ios_notification_groups";
export const engagementIosNotificationGroupsCacheKeys: AllRouteEndpoints[] = [engagementIosNotificationGroups];
